import React, { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useAuthState } from 'react-firebase-hooks/auth'
import { firebase_auth } from '../../config/firebaseConfig'
import { useCallableRef } from '../../api/useCallableRef'
import ProgressCircle from '../components/ProgressCircle'

export default function ExternalRedirect({ children }: any) {
  const { state } = useLocation()
  let { link: externalLink } = (state as { link?: string; passedInPath?: string }) || {}
  const [token, setToken] = useState<string | null>(null)
  const [searchParams] = useSearchParams()

  const [user, loading] = useAuthState(firebase_auth)
  const [createToken, loadingCreateToken] = useCallableRef('createTokenCallable')

  useEffect(() => {
    async function generateAndSetToken() {
      if (!token && !loadingCreateToken) {
        const tokenResponse = await createToken()
        // @ts-expect-error tokenResponse.data type
        setToken(tokenResponse.data)
      }
    }

    if (user && !loading) {
      void generateAndSetToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    const link_qp = searchParams.get('link')

    if (token) {
      if (!state && link_qp) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        externalLink = link_qp
      }

      window.location.href = `${externalLink}?authToken=${token}`
    }
  }, [token])

  return (
    <>
      <ProgressCircle />
      {children}
    </>
  )
}
